export default {
        PhoneNum:"Nomor Telepon",
        email:"Email",
        address:"Alamat Kantor",
        // dizhi:"80 Robinson Road #02-00 Singapore 068898",
        dizhi:"Infiniti Office 1st Floor SA 1-06, Permata Regency D/37 Kel. Srengseng, Kec. Kembangan Jakarta Barat, Indonesia 11630",
        contactUs:"Hubungi Kami",
};
